export const holidaysCollectionGuard = 'GET /v2/franchises';
export const holidaysResourceGuard = 'GET /v2/franchises/d+';

export const createHolidaysResourceGuard = 'POST /v2/franchises';
export const updateHolidaysResourceGuard = 'PUT /v2/franchises/d+';
export const deleteHolidaysGuard = 'DELETE /v2/franchises/d+';
